import { render, staticRenderFns } from "./Permissao.vue?vue&type=template&id=076ca9b2&scoped=true"
import script from "./Permissao.vue?vue&type=script&lang=js"
export * from "./Permissao.vue?vue&type=script&lang=js"
import style0 from "./Permissao.vue?vue&type=style&index=0&id=076ca9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ca9b2",
  null
  
)

export default component.exports